import { usePanelWidth } from './usePanelWidth';

const ISSUES_PANEL_CONFIG = {
  storageKey: 'issuesPanelWidth',
  defaultWidth: 755,
  minWidth: 600,
  minContentWidth: 700, // Minimum width for chat area + buffer for sidebar
};

export const useIssuesPanelWidth = () => {
  return usePanelWidth(ISSUES_PANEL_CONFIG);
};
